import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const ArticlePublishedTimeWrapper = styled('time')(
    ({ theme }) => css`
        display: block;
        margin-bottom: ${theme.spacing['16px']};
        font-weight: ${theme.type.normal};
        font-size: ${theme.fontSizes[2]};
        color: ${theme.colors['grey-steel']};
    `
);
